/**
 * Display-only cleanup for service names on customer-facing surfaces.
 *
 * Catalogue names double as pricing SKUs — "Sofa Per Seat (Maximum 2ft)",
 * "Carpet Per Sq.ft" — which reads unit-first on the Step 1 cards. Customers
 * think "I have a sofa", not "I need a per-seat SKU", so the cards/sheet/
 * summary strip show the ITEM name and leave the unit to the price line
 * ("From ₹1,100/seat") and the sheet subtitle ("₹1,100 per seat · 1 seat =
 * up to 2 ft wide").
 *
 * Strictly presentational: booking payloads, admin views, and emails keep
 * the raw catalogue name, so ops/finance still see the exact SKU.
 */

/** "Sofa Per Seat (Maximum 2ft)" → "Sofa" · "Carpet Per Sq.ft" → "Carpet".
 *  Names without a unit suffix ("Full Bed (Headboard + 3 sides)", "Loose
 *  Cushions") pass through unchanged. Falls back to the original when
 *  stripping would leave an empty string. */
export function cleanServiceTitle(name?: string | null): string {
  if (!name) return '';
  const raw = String(name);
  let out = raw;
  // Unit-constraint parentheticals only — "(Maximum 2ft)", "(max 2 ft)".
  // Descriptive parentheticals like "(Headboard + 3 sides)" are kept.
  out = out.replace(/\(\s*max(?:imum)?[^)]*\)/gi, '');
  // Pricing-unit suffixes — "Per Seat", "Per Sq.ft", "Per Pc", "Per Piece".
  out = out.replace(/\s+per\s+(?:seat|sq\.?\s*ft\.?|sqft|pc|piece|item)\b\.?/gi, '');
  out = out.replace(/\s{2,}/g, ' ').trim();
  return out || raw.trim();
}
